import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbOffcanvas, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CompositionService } from '../../../../../core/services/composition.service';
import { FileService } from '../../../../../core/services/file.service';
import { NoteService } from '../../../../../core/services/note.service';
import { PeriodService } from '../../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import {FileService as myFileService} from '../../../../../core/utils/file-service'
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-composition-by-classroom',
    templateUrl: './composition-by-classroom.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./composition-by-classroom.component.css']
})
export class CompositionByClassroomComponent {

  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  notes:any[] =[]
  periods:any[] =[]
  compositions:any[] =[]
  compositions2:any[] =[]
  courses:any[] =[]
  pacs:any[] =[]
  selected_data:any;
  modalOption:any; 
  pacId:any; 
  periodId:any; 
  currentCompositon:any; 
  isDtInitialized:boolean = false
  is_published=null
  loading=false
  canCalculate=false
  tag="admin-composition-by-classrooms"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any

  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined


  constructor(
    private spinnerService:NgxSpinnerService,
    private noteService:NoteService,
    private fileService:FileService,
    private compService:CompositionService,
    private periodService:PeriodService,
    private sacService:StudentAyClassroomService,
    private classroomService:ClassroomService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getPeriods()
    this.getClassrooms()
    this.currentCompositon=undefined
  }

  getPeriods(){
    this.periodService.getByState(1).subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des compositions",err)
    })
  }

  setPacId(event:any){
    this.pacId=event.target.value
    //this.courses=this.pacs.find((el:any)=>el.id==event.target.value).courses
  }

  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
    })
  }
  getFile2(path:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      path:path
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
    })
  }

  open(i:any){
    this.pdfSrc=this.data[i].motif_file
    this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

  }
 

  getStudentAcademicClassroomList(classroomId:any){
    this.sacService.getAll(classroomId).subscribe((res:any)=>{
      res.data.forEach((element:any) => {
        this.data.push({
          id:element.id,
          code:element.student?.code,
          photo:element.photo,
          name:element.student?.firstname+" "+element.student?.lastname,
          value:0,
          isSetted:1,
          motif:"",
          motif_file:"",
          appreciation:"",
          hasFile:false
        })
      });
      
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des compositions",err)
    })
  }
  getClassrooms(){
    this.classroomService.getByState(1).subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des compositions",err)
    })
  }
  loadCompositions1(event:any){
    this.pacId=event.target.value
    if (this.pacId != undefined && this.periodId!=undefined) {
      this.compService.getByClassroomPeriodsState(this.pacId,this.periodId).subscribe((res:any)=>{
        this.compositions=res.data
        this.pg.total=res.data.length
        this.checkifCalculate()
      },
      (err:any)=>{
  
      })
    } 
   
  }

  checkifCalculate(){
    this.compositions.forEach((el:any)=>{
      if(el.compositions.length!=0)this.canCalculate=true
    })
  }
  loadCompositions2(event:any){
    this.periodId=event.target.value

    if (this.pacId != undefined && this.periodId!=undefined) {
      this.compService.getByClassroomPeriodsState(this.pacId,this.periodId).subscribe((res:any)=>{
        this.compositions=res.data
        this.pg.total=res.data.length

        this.checkifCalculate()
      },
      (err:any)=>{
  
      })
    } 
   
  }
  loadNotes(event:any){
      this.currentCompositon=this.compositions.find((el:any)=>el.id==event.target.value)
      this.noteService.getByComposition(event.target.value).subscribe((res:any)=>{
        this.data=res.data
      },
      (err:any)=>{
  
      })
  }


  resetNote(event:any, i:any){
      if(event.target.value=="0")this.data[i].value=0
      this.data[i].isSetted=event.target.value=="0"?0:1
  }


  async upload(ev:any, i:any){
    if (ev.target.files.length!=0) {
      this.data[i].motif_file=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(ev.target.files[0]))
      this.data[i].hasFile=true
    }
  }


  loadlist(e:any){
    this.getStudentAcademicClassroomList(e.target.value)
  }

  remove(i:any){
    this.data[i].motif_file=""
    this.data[i].hasFile=false  
  }


  store(value:any){
    this.loading=true
    console.log(this.data)
    this.noteService.store({
      composition_id:value.composition_id,
      notes:this.data
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
  update(value:any){
    this.loading=true

    this.sacService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.sacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
})
  }
  publish(){
    let confirmed=AppSweetAlert.confirmBox('success','Note de composition','Voulez vous vraiment valider les notes de cette composition élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.compService.validate(this.currentCompositon.id,1).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.init()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_published=el.is_published
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any,compositions:any){
   // if(!this.verifyIfElementChecked()) return ;
   // this.modalOption={centered:false,size:"lg"}
   this.compositions2=compositions
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
    this.loading=true
        this.compService.validate(this.selected_data.id,value).subscribe((res:any)=>{
          this.loading=false
          this.compService.getByClassroomPeriods(this.pacId,this.periodId).subscribe((res:any)=>{
            this.compositions=res.data
          },
          (err:any)=>{
            AppErrorShow.showError("Gestion des compositions",err)

          })
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        this.loading=false

        console.log(err)
          AppErrorShow.showError("Gestion des permissions",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  getState(compositions:any){
    let sent=compositions.filter((el:any) => el.is_confirmed==true).length
    let published = compositions.filter((el:any) => el.is_published==true).length;

    return `${published}/${sent}`; 
  }


  generateBulletin(){

    if (this.pacId != undefined && this.periodId!=undefined) {
      this.spinnerService.show()
      this.loading=true
      this.compService.generateBulletin(this.pacId,this.periodId).subscribe((res:any)=>{
        this.spinnerService.hide()
        this.loading=false
        this.toastrService.success(res.message)
        // this.getFile2(res.data.path)
      },
      (err:any)=>{
        this.spinnerService.hide()
        this.loading=false
        AppErrorShow.showError("Gestion des compositions",err)

      })
    } 
  }
  getPage(event:any){
    this.pg.p=event
  }
}
